// extracted by mini-css-extract-plugin
export default {"methodsWrapper":"Methods_methodsWrapper__-G3hH","methodsContent":"Methods_methodsContent__eQAGr","methods":"Methods_methods__yHDky","methodEl":"Methods_methodEl__pAL2L"};